<div id="pag-div-1" class="container-paginator">
  <div id="pag-div-2" class="label-paginator copec-lg-14">
    

  </div>
  <div id="pag-div-3"
    class="d-flex align-items-center justify-content-end container-button-paginator copec-rg-16"
  >
    <button id="pag-button-1" *ngIf="!isSizeMobile" (click)="firstPagePaginatorSelect()">
      <i id="pag-id-1" class="fa-solid fa-angles-left"></i>
    </button>
    <button (click)="prevPagePaginatorSelect()"><i class="fa-solid fa-angle-left"></i></button>
    <button id="pag-button-1-{{page}}"
      *ngFor="let page of buttonPages"
      (click)="onPageChangePaginatorSelect(page)"
      [ngClass]="{ selected: currentPage === page }"
    >
      {{ page }}
    </button>
    <button id="pag-button-2" (click)="nextPagePaginatorSelect()">
      <i class="fa-solid fa-angle-right"></i>
    </button>
    <button id="pag-button-3" *ngIf="!isSizeMobile" (click)="lastPagePaginatorSelect()">
      <i id="pag-id-2" class="fa-solid fa-angles-right"></i>
    </button>
  </div>
</div>